const PRODUCTION = "production"
export const IS_PRODUCTION = process.env.NODE_ENV === PRODUCTION

const DEVELOPMENT = "development"
export const IS_DEVELOPMENT = process.env.NODE_ENV === DEVELOPMENT
